<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-actions
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllEcheanceBafSelected().length > 0"
            ></selecteur-actions>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeCommandes.actions.search')"
                     v-model="critereRecherche.auto"
                     type="search"
                     icon="magnify">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeCommandes.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permCommandes.exporter"
            in-progress/>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class='column is-narrow'>
        <date-picker :dates="critereRecherche.dates" @recherche="recherche"/>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" @loaded="finLoading"
                    @loading="debutLoading" ref="tablelisteEcheanceBaf">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tablelisteEcheanceBaf.setLimit($event)" />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="bafCommande">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props"
           class="has-text-centered">
        <b-checkbox v-model="props.row.selected" :value="props.row"
        :disabled="props.row.facturationFaite"></b-checkbox>
      </div>
      <div slot="setBaf" class="has-text-centered"
           slot-scope="props">
        <button class="button is-primary is-fullwidth" @click="prepareChangementEtatBaf(props.row)"
        :class="{'disabled': props.row.facturationFaite}">
          {{ props.row.bonAFacturer ? $t('commandeBaf.actions.bafCancel')
          : $t('commandeBaf.tab.baf')}}
        </button>
      </div>
      <div slot="code" slot-scope="props">
        <router-link-blank :to="{ name: 'c.bodac.commandes', params: { id: props.row.commandeId }}"
                           :message="props.row.code">
        </router-link-blank>
      </div>
      <div slot="typeProduit" slot-scope="props">
        <p v-for="(type, index) in getProduit(props.row)" :key="index">
          {{ props.row.lignesCommandeRegroupementLibelle.length > 1 ? type : '- ' + type }}
        </p>
      </div>
      <div slot="patrimoine" slot-scope="props">
        {{ getPatrimoine(props.row) }}
      </div>
      <div slot="annonceur" slot-scope="props">
        <router-link-blank v-for="(annonceur, index) in props.row.annonceursNomsCommerciauxIds"
                           :key="index"
                           v-bind="getRouteAnnonceur(annonceur)">
        </router-link-blank>
      </div>
      <div slot="fournisseursNomsCommerciaux" slot-scope="props">
        <router-link-blank v-for="(fournisseurId, index) in props.row.fournisseursId"
                           :key="index"
                           :to="{ name: 'c.gabed.confrere',
                           params: { id: fournisseurId,
                           sousTypeFrom: constantes.TIERS_SOUS_TYPE_CONFRERE }}"
                           :message="props.row.fournisseursNomsCommerciaux[index]">
        </router-link-blank>
      </div>
      <div slot="payeurNomCommercial" slot-scope="props">
        <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
                           params: { id: props.row.payeurId }}"
                           :message="props.row.payeurNomCommercial">
        </router-link-blank>
      </div>
      <div slot="assistantNom" slot-scope="props">
        <router-link-blank v-if="props.row.assistantId"
                           :to="{ name: 'c.parametrage.collaborateurs',
                           params: { id: props.row.assistantId }}"
                           :message="props.row.assistantNom + ' ' + props.row.assistantPrenom">
        </router-link-blank>
      </div>
      <div slot="dateDebut" slot-scope="props">
        {{ props.row.dateDebut | formatDate }}
      </div>
      <div slot="dateFin" slot-scope="props">
        {{ props.row.dateFin | formatDate }}
      </div>
      <div slot="montantHt" slot-scope="props" class="has-text-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="bonAFacturer" slot-scope="props">
        {{ props.row.bonAFacturer ? $t('general.oui') : $t('general.non') }}
      </div>
      <div slot="dateBonAFacturer" slot-scope="props">
        {{ props.row.dateBonAFacturer | formatDate }}
      </div>
      <div slot="aFacturer" slot-scope="props">
        {{ props.row.aFacturer ? $t('general.oui') : $t('general.non') }}
      </div>
      <div slot="facture" slot-scope="props">
        {{ props.row.facturationFaite ? $t('general.oui') : $t('general.non') }}
      </div>
      <div slot="quiBonAFacturer" slot-scope="props">
        {{ getUserWhoFacture(props.row) }}
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-echeance-baf ref="filtreListeBonAFacturer"
                             @toggleFiltre="changeValueShowFiltreAndLockMenu()"
                             @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
    <b-modal v-model="popUpChangementBaf"
             has-modal-card
             class="modal">
    <pop-up-prevention :messHeader="echeanceToUpdateBaf.length > 1
    ? this.$t('commandeBaf.popUpPrevention.titleMultiple')
    : this.$t('commandeBaf.popUpPrevention.title')"
      :cancel="this.$t('general.non')"
      :validate="this.$t('general.oui')"
      @no="popUpChangementBaf = false"
      @yes="changementEtatBaf()"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import selecteurActions from '@/components/general/selecteurAction';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import filtreEcheanceBaf from '@/components/commande/baf/filtreEcheanceBaf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import detailProduitEcheance from '@/components/commande/baf/detailProduitEcheance';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import datePicker from '@/components/general/datePicker';
import formatIsoDate from '@/services/general/formatIsoDate';
import { TIERS_SOUS_TYPE_CONFRERE } from '@/configuration/tiers/tiersConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import { updateBaf } from '@/api/echeancier/index';
import { SET_BAF_TO_FALSE, SET_BAF_TO_TRUE } from '@/configuration/commande/bafCommandeActionsConf';
import messageSuccess from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';

const Societe = createNamespacedHelpers('societe');
const CommandesBaf = createNamespacedHelpers('bafCommande');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'echeancesBonAFacturer',
  data() {
    return {
      actions: [
        { action: SET_BAF_TO_TRUE, translation: 'commandeBaf.actions.activerBaf' },
        { action: SET_BAF_TO_FALSE, translation: 'commandeBaf.actions.bafCancel' },
      ],
      unsubscribeValue: null,
      showFiltre: false,
      permCommandes: COMMANDES,
      constantes: {
        TIERS_SOUS_TYPE_CONFRERE,
      },
      popUpChangementBaf: false,
      echeanceToUpdateBaf: [],
      bafStatus: null,
    };
  },
  components: {
    selecteurActions,
    TableItemsInView,
    filtreEcheanceBaf,
    routerLinkBlank,
    datePicker,
    popUpPrevention,
    tableFooterTotaux,
    exportExcelButton,
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...CommandesBaf.mapGetters({
      bafCommande: 'bafCommande',
      totalBafCommande: 'totalBafCommande',
      critereRecherche: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    nombreCritere() {
      const banCritere = ['auto', 'sens', 'societeId', 'dates', 'datesBaf'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.aFacturer === false) nbCritere += 1;
      if (this.critereRecherche.bonAFacturer === false) nbCritere += 1;
      if (this.critereRecherche.facturationFaite === false) nbCritere += 1;
      if (this.critereRecherche.datesBaf.dateDebut || this.critereRecherche.datesBaf.dateFin) {
        nbCritere += 1;
      }
      return nbCritere;
    },
    iconSelectTotal() {
      if (this.allEcheanceBafSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allEcheanceBafSelected() {
      return this.getAllEcheanceBafSelected().length === this.bafCommande.filter((echeance) => {
        return !echeance.facturationFaite;
      }).length
        && this.bafCommande.filter((echeance) => {
          return !echeance.facturationFaite;
        }).length > 0;
    },
    targetTotal() {
      return ['montantHt'];
    },
    totalMontantHt() {
      const total = this.bafCommande
        .map(f => f.montantHt)
        .reduce((a, b) => a + b, 0);
      this.refreshTotal(total);
      return total;
    },
    columns() {
      return ['selected', 'setBaf', 'code', 'patrimoine', 'typeProduit', 'fournisseursNomsCommerciaux', 'annonceur', 'payeurNomCommercial', 'dateDebut', 'dateFin', 'montantHt', 'codeDossier', 'assistantNom', 'bonAFacturer', 'dateBonAFacturer', 'quiBonAFacturer', 'aFacturer', 'facture'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          setBaf: '',
          code: this.$i18n.t('commandeBaf.tab.nCommande'),
          patrimoine: this.$i18n.t('commandeBaf.tab.patrimoine'),
          typeProduit: this.$i18n.t('commandeBaf.tab.typeProduit'),
          fournisseursNomsCommerciaux: this.$i18n.t('commandeBaf.tab.fournisseur'),
          annonceur: this.$i18n.t('commandeBaf.tab.annonceur'),
          payeurNomCommercial: this.$i18n.t('commandeBaf.tab.Payeur'),
          dateDebut: this.$i18n.t('commandeBaf.tab.dateDebut'),
          dateFin: this.$i18n.t('commandeBaf.tab.dateFin'),
          montantHt: this.$i18n.t('commandeBaf.tab.montantHt'),
          assistantNom: this.$i18n.t('commandeBaf.tab.assistant'),
          bonAFacturer: this.$i18n.t('commandeBaf.tab.baf'),
          dateBonAFacturer: this.$i18n.t('commandeBaf.tab.dateBaf'),
          quiBonAFacturer: this.$i18n.t('commandeBaf.tab.quiBAF'),
          aFacturer: this.$i18n.t('commandeBaf.tab.aFacturer'),
          codeDossier: this.$i18n.t('commandeBaf.tab.codeDossier'),
          facture: this.$i18n.t('commandeBaf.tab.facture'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['code', 'payeurNomCommercial', 'dateDebut', 'dateFin', 'montant', 'fournisseursNomsCommerciaux', 'assistantNom', 'dateBonAFacturer', 'quiBonAFacturer', 'aFacturer', 'codeDossier'],
        columnsClasses: {
          selected: 'colonneSelected',
          setBaf: 'is-paddingless',
        },
        childRow: this.hasMultiProduitOrPatrimoine ? detailProduitEcheance : null,
        rowClassCallback: ((row) => {
          if (!row.lignesCommandeRegroupementLibelle
            || (row.lignesCommandeRegroupementLibelle.length <= 1
            && this.hasMultiProduitOrPatrimoine)) {
            return 'hideChildToggler disableChildRowClick';
          }
          return 'activeChildRowClick';
        }),
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.critereRecherche);
          if (data.query.fournisseursId.length > 0) {
            data.query.fournisseursId = data.query.fournisseursId.map((fournisseur) => {
              return fournisseur.id;
            });
          }
          if (data.query.annonceursId.length > 0) {
            data.query.annonceursId = data.query.annonceursId.map((annonceur) => {
              return annonceur.id;
            });
          }
          if (data.query.groupeIds.length > 0) {
            data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
          }
          if (data.query.enseigneIds.length > 0) {
            data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => {
              return enseigne.id;
            });
          }
          if (data.query.payeursId.length > 0) {
            data.query.payeursId = data.query.payeursId.map((payeur) => {
              return payeur.id;
            });
          }
          data.query.dates.dateDebut = formatIsoDate(data.query.dates.dateDebut);
          data.query.dates.dateFin = formatIsoDate(data.query.dates.dateFin);
          if (data.query.datesBaf.dateDebut && data.query.datesBaf.dateFin) {
            data.query.datesBaf.dateDebut = formatIsoDate(data.query.datesBaf.dateDebut);
            data.query.datesBaf.dateFin = formatIsoDate(data.query.datesBaf.dateFin);
          } else {
            data.query.datesBaf = null;
          }
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadCommandesBaf(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.bafCommande,
            count: this.totalBafCommande,
          };
        }),
      };
    },
    hasMultiProduitOrPatrimoine() {
      return this.bafCommande.some((commande) => {
        return commande.lignesCommandeRegroupementLibelle
          && commande.lignesCommandeRegroupementLibelle.length > 1;
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...CommandesBaf.mapActions({
      actionsLoadCommandesBaf: 'loadCommandeBaf',
    }),
    getRouteAnnonceur(nomId) {
      return {
        to: {
          name: 'c.bodac.clients/contacts-client',
          params: {
            id: nomId.split('#')[1],
          },
        },
        message: nomId.split('#')[0],
      };
    },
    getUserWhoFacture(echeance) {
      const user = (this.parametre(PARAMETRES_KEYS.utilisateur)).find((user) => {
        return user.id === echeance.quiBonAFacturer;
      });
      if (!user) return '';
      return nomPrenomGetter(user);
    },
    refreshTotal(total) {
      if (this.$refs.total) {
        this.$refs.total.innerHTML = this.$options.filters.formatDevise(total);
      }
    },
    async changementEtatBaf() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpChangementBaf = false;
        await updateBaf({
          ids: this.echeanceToUpdateBaf.map((el) => el.id),
          baf: this.bafStatus,
        });
        messageSuccess(this.$i18n.t('commandeBaf.success.changementEtatSuccess'));
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    prepareChangementEtatBaf(echeance) {
      this.bafStatus = !echeance.bonAFacturer;
      this.popUpChangementBaf = true;
      this.echeanceToUpdateBaf = [echeance];
    },
    async societeCanViewPage() {
      if (this.societeActive.activerBonAFacturer) {
        this.loadingComponent.close();
        return;
      }
      await this.$router.push({ name: 'l.bodac.commandes-liste' });
    },
    getAllEcheanceBafSelected() {
      return this.bafCommande.filter((el) => { return el.selected && !el.facturationFaite; });
    },
    getProduit(commandeBaf) {
      if (commandeBaf.lignesCommandeLibelle.length === 0) return [];
      if (commandeBaf.lignesCommandeRegroupementLibelle.length > 1) {
        return [this.$i18n.t('commandeBaf.tab.multiProduit')];
      }
      return commandeBaf.lignesCommandeLibelle;
    },
    getPatrimoine(commandeBaf) {
      if (!commandeBaf.lignesCommandeRegroupementLibelle
        || commandeBaf.lignesCommandeRegroupementLibelle.length === 0) return '';
      if (commandeBaf.lignesCommandeRegroupementLibelle.length > 1) {
        return this.$i18n.t('commandeBaf.tab.multiPatrimoine');
      }
      return commandeBaf.lignesCommandeRegroupementLibelle[0];
    },
    selectAll() {
      const select = !this.allEcheanceBafSelected;
      this.bafCommande
        .filter((el) => { return !el.facturationFaite; })
        .forEach((el) => {
          el.selected = select;
        });
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeBonAFacturer.initializeFiltre();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    recherche() {
      this.$refs.tablelisteEcheanceBaf.refresh();
    },
    handleAction(action) {
      this.popUpChangementBaf = true;
      this.echeanceToUpdateBaf = cloneDeep(this.getAllEcheanceBafSelected());
      switch (action) {
        case SET_BAF_TO_TRUE:
          this.bafStatus = true;
          break;
        case SET_BAF_TO_FALSE:
          this.bafStatus = false;
          break;
        default:
          break;
      }
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    async reinitialiser() {
      await this.$refs.filtreListeBonAFacturer.initializeFiltre();
      this.$refs.filtreListeBonAFacturer.viderCritere();
      this.$refs.filtreListeBonAFacturer.appliquerCritere();
      this.showFiltre = false;
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.societeCanViewPage, this.recherche);
      this.setInformationPage(this.$t('pageGescom.commande.listeCommandeBAF'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
